// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AUAjb","colBig":"styles_colBig__LkCo9","colSmall":"styles_colSmall__2naB4","shopifyNameWrapper":"styles_shopifyNameWrapper__wv5Xc"};